import { gql } from '@apollo/client';

export const CREATE_PROSPECT = gql`
  mutation CreateProspect(
    $name: String!
    $cif: String!
    $address: String!
    $paymentTerms: String!
    $companyName: String!
    $category: String
    $sector: String
    $source: String
    $referralName: String
  ) {
    createBrand(
      name: $name
      cif: $cif
      address: $address
      paymentTerms: $paymentTerms
      companyName: $companyName
      isProspect: true
      category: $category
      sector: $sector
      source: $source
      referralName: $referralName
    ) {
      status
      code
      data
      error
    }
  }
`;
